<div class="chapter-list">

  <div class="list-header">
    <h2>{{ 'chapters' | transloco }}</h2>

    <button class="molv-btn molv-btn-pink" (click)="addChapter()">
      + {{ 'addChapter' | transloco }}
    </button>
  </div>

  <movl-chapter-item *ngFor="let chapter of chapters()" [chapter]="chapter" [isGlobalEditMode]="isEditMode()">
  </movl-chapter-item>

</div>